<button mat-button class="button button-unthemed"
        (click)="emit_onClick($event)"
        [style.--btn-icon-color]="_iconColor$$()"
        [attr.form]="formName$$()"
        [attr.type]="type$$()"
        [autofocus]="autofocus$$()"
        [class]="class$$()"
        [disabled]="_disabled$$()"
        disabledInteractive
        [matTooltipPosition]="tooltipPosition$$()"
        [matTooltip]="tooltip$$()"
        [style]="style$$()"
        [tabindex]="tabIndex$$()"
        [type]="type$$()"
    >
    <div class="content">
        <ng-content />
    </div>
</button>
